import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';
import { API_ENDPOINTS } from './api-endpoints';

const override = {
  PERFORM_APP_DYNAMICS: API_ENDPOINTS.PERFORM_APP_DYNAMICS.DEV,
  hostname: API_ENDPOINTS.HOSTNAME.DEV,
  RTI_ENDPOINT: API_ENDPOINTS.RTI_ENDPOINT.DEV,
  RTI_X_API_VALUE: API_ENDPOINTS.RTI_X_API_VALUE.DEV,
  RTI_X_API_KEY: API_ENDPOINTS.RTI_X_API_KEY.COMMON,
  PP_ENDPOINT: API_ENDPOINTS.PP_ENDPOINT.DEV,
  DIS_ENDPOINT: API_ENDPOINTS.DIS_ENDPOINT.DEV,
  DIS_X_API_VALUE: API_ENDPOINTS.DIS_X_API_VALUE.DEV,
  DIS_X_API_KEY:API_ENDPOINTS.DIS_X_API_KEY.COMMON,
  APP_DYNAMIC_KEY: API_ENDPOINTS.APP_DYNAMIC_KEY.DEV,
  CREDIT_APP_ENPOINT:API_ENDPOINTS.CREDIT_APP_ENPOINT.DEV,
  GOOGLE_MAP_API_KEY: API_ENDPOINTS.GOOGLE_MAP_API_KEY.DEV,
  WAF_URL: API_ENDPOINTS.WAF_URL.DEV,
};

export const environment = defaultsDeep(override, environmentDefaults);
